// Redux
import { Dispatch } from "redux";

// Action Creators
import { setNewList } from "../actionCreators/attributes.actionCreators";

export const setNewListValue = (dispatch: Dispatch<any>, value: boolean) => {
  dispatch(setNewList(value));
};
